export default "__VITE_ASSET__DcKoYG3n__"